import { ApiService } from "@/api";
import crc32 from "buffer-crc32";
import { base58 } from "@scure/base";

export default {
  GET_CAMERAS({ commit }, payload) {
    commit("SET_CAMERAS_LIST_LOADING", true);
    const params = {
      ...payload,
      search: encodeURI(payload.query) || "",
    }
    delete params.query
    return ApiService.cameras
      .getList(params)
      .then((data) => {
        commit("SET_LIST_CAMERAS", data);
        return data;
      })
      .finally(() => {
        commit("SET_CAMERAS_LIST_LOADING", false);
      });
  },
  GET_CAMERA({ commit }, id) {
    commit("SET_CAMERA_LOADING", true);
    return ApiService.cameras
      .get(id)
      .then((data) => {
        commit("SET_CAMERA", data);
        return data;
      })
      .finally(() => {
        commit("SET_CAMERA_LOADING", false);
      });
  },
  GET_CAMERA_STREAM({ commit }, id) {
    return ApiService.cameras
      .getStream(id)
      .then((data) => {
        commit("SET_CAMERA_PARAMETER", data);
        return data;
      })
  },
  GET_CAMERA_GREY_RTSP_LINK({ commit }, id) {
    return ApiService.cameras
      .getGreyRtspLink(id)
      .then((data) => {
        commit("SET_CAMERA_PARAMETER", data);
        return data;
      })
  },
  GET_CAMERA_CREDENTIALS_ONVIF({ commit }, id) {
    return ApiService.cameras
      .getCredentialsOnvif(id)
      .then((data) => {
        commit("SET_CAMERA_PARAMETER", data);
        return data;
      })
  },
  GET_CAMERA_CREDENTIALS({ commit }, id) {
    return ApiService.cameras
      .getCredentials(id)
      .then((data) => {
        commit("SET_CAMERA_PARAMETER", data);
        return data;
      })
  },
  GET_CAMERA_PREVIEW_PATH({ commit }, id) {
    return ApiService.cameras
      .getPreviewPath(id)
      .then((data) => {
        commit("SET_CAMERA_PARAMETER", data);
        return data;
      })
  },
  DELETE_CAMERA(context, id) {
    return ApiService.cameras.delete(id);
  },
  UPDATE_CAMERA(context, { id, data: newCamera }) {
    return ApiService.cameras.update(id, newCamera);
  },
  GET_OPERATOR_CAMERAS_PARAMETERS({ commit }) {
    return ApiService.cameras
      .getParameters()
      .then((data) => {
        commit("SET_CAMERAS_PARAMETERS", data);
        return data;
      });
  },
  SWITCH_ON_CAMERA(context, id) {
    return ApiService.cameras.switchState(id, "active");
  },
  SWITCH_OFF_CAMERA(context, id) {
    return ApiService.cameras.switchState(id, "not_active");
  },
  REBOOT_CAMERA(context, id) {
    return ApiService.cameras.rebootCamera(id);
  },
  UPDATE_ARCHIVE_DEPTH(context, { id, archive_depth }) {
    return ApiService.cameras.updateArchiveDepth(id, archive_depth);
  },
  UPDATE_TARIFF(context, { id, id_tariff }) {
    return ApiService.cameras.updateTariff(id, id_tariff);
  },
  UPDATE_DVR_SERVER(context, { id, id_dvr_server, force }) {
    return ApiService.cameras.updateDvrServer(id, id_dvr_server, force);
  },
  UPDATE_PROXY_SERVER(context, { id, id_proxy_server }) {
    return ApiService.cameras.updateProxyServer(id, id_proxy_server);
  },
  MIGRATE_MEDIA_CORE(context, { id, id_server, id_proxy_server }) {
    return ApiService.cameras.migrateMediaCore(id, id_server, id_proxy_server);
  },
  UPDATE_CAMERA_ONVIF_DATETIME(context, { id, hour, minute, second, year, month, day, timezone }) {
    return ApiService.cameras.updateCameraOnvifDatetime(id, hour, minute, second, year, month, day, timezone);
  },
  GET_CAMERA_RECIPIENTS({ commit }, id_camera) {
    return ApiService.cameras.getRecipients(id_camera).then((recipients) => {
      commit("SET_CAMERA_RECIPIENTS", recipients);
    });
  },
  REMOVE_CAMERA_RECIPIENT({ dispatch }, { id_camera, id_camera_share }) {
    return ApiService.cameras.deleteRecipient(id_camera, id_camera_share).then(() => {
      dispatch("GET_CAMERA_RECIPIENTS", id_camera);
    });
  },
  ADD_CAMERA_RECIPIENT({ dispatch }, { id_camera, id_recipient, is_access_archive, is_access_sound, is_notify_by_push, is_notify_by_telegram }) {
    return ApiService.cameras.addRecipient(id_camera,
      { id_recipient, is_access_archive, is_access_sound, is_notify_by_push, is_notify_by_telegram }).then(() => {
      dispatch("GET_CAMERA_RECIPIENTS", id_camera);
    });
  },
  UPDATE_CAMERA_RECIPIENT({ dispatch }, { id_camera, id_camera_share, is_access_archive, is_access_sound, is_notify_by_push, is_notify_by_telegram }) {
    return ApiService.cameras.updateRecipient(id_camera,
      { id_camera_share, is_access_archive, is_access_sound, is_notify_by_push, is_notify_by_telegram }).then(() => {
      dispatch("GET_CAMERA_RECIPIENTS", id_camera);
    });
  },
  GET_CONFIG(context, id) {
    return ApiService.cameras.getConfig(id)
  },
  SET_CONFIG({ commit }, { id, config }) {
    return ApiService.cameras.updateConfig(id, config)
      .then(config => commit("SET_CONFIG", config))
  },
  RESET_SETTIGNS(_ , id) {
    return ApiService.cameras.resetConfig(id)
  },
  GET_AUTH_KEY(_, { id, type }) {
    return ApiService.cameras.getAuthKey(id, type);
  },
  GET_MODEL({ commit }, id) {
    return ApiService.models.get(id)
      .then(model => commit("SET_MODEL", model))
  },
  GET_CAMERA_AGENT_STATUS({ commit }, idCamera) {
    return ApiService.cameras.getCameraAgentStatus(idCamera)
      .then(data => commit("SET_CAMERA_AGENT_STATUS", data[0]?.agent_status))
  },
  GET_CAMERA_STREAMS_URLS({ commit }, id) {
    return ApiService.cameras.getCameraStreamsUrls(id)
      .then(data => commit("SET_CAMERA_STREAMS_URLS", data))
  },
  GET_CAMERA_PUBLISH_URLS({ commit, state }, id) {
    return ApiService.cameras.getPublishUrls(id)
      .then(data => {
        if (!!state.camera.is_monitor) {
          let monitorLinkJson = {
            rtmp_url: data.publish_urls[0].publish_url,
            serial_number: state.camera.serial_number,
          };
          const hash = crc32.signed(JSON.stringify(monitorLinkJson));
          monitorLinkJson = { ...monitorLinkJson, hash: hash.toString() };
          const encodedString = new TextEncoder().encode(JSON.stringify(monitorLinkJson));
          const encodedData = base58.encode(encodedString);
          let publish_urls = [];
          let publish_url = {
            id_camera: state.camera.id_camera,
            id_account_master: state.camera.id_account_master,
            publish_url: "linkvideomonitor:" + encodedData,
            stream_name: "LinkVideo.Monitor",
          };
          publish_urls.push(publish_url);
          commit("SET_CAMERA_PARAMETER", { publish_urls })
        } else {
          commit("SET_CAMERA_PARAMETER", data)
        }
      })
  },
  GET_CAMERA_STREAMS_DATA({ commit }, id) {
    return ApiService.cameras.getStreamsData(id)
      .then(data => commit("SET_CAMERA_PARAMETER", data))
  },
  GET_CAMERAS_CONFIG_PARAMETERS() {
    return ApiService.cameras.getConfigParameters()
  },
  GET_CAMERA_PARAMETERS(context, id) {
    return ApiService.cameras.getCameraParameters(id)
  },
  SET_CAMERA_PARAMETERS(context, payload) {
    return ApiService.cameras.setCameraParameters(payload.id, payload.data)
  },
  DELETE_CAMERA_PARAMETERS(context, id) {
    return ApiService.cameras.deleteCameraParameters(id)
  },
  GET_CAMERA_INSTALLATION_LOCATIONS() {
    return ApiService.cameras.getInstallationLocations()
  },
  GET_MOTION_DETECTION_INSTANCES() {
    return ApiService.cameras.getMotionDetectionInstances()
  },
  GET_CAMERA_SHARES_HISTORY(context, { id, page, count }) {
    return ApiService.cameras
      .getCameraSharesHistory(id, { page, count })
      .then((data) => {
        return { items: data.data, total: data.total };
      });
  },
};
